import * as React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    Spinner,
} from '@fluentui/react-components';
import ErrorBar from './ErrorBar';

export interface IConfirmDialogProps {
    open: boolean;
    title: string;
    children: React.ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    busy?: boolean;
    busyLabel?: string;
    error?: string;
    danger?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmDialog: React.FC<IConfirmDialogProps> = ({
    open, title, children, confirmLabel = 'Подтвердить', cancelLabel = 'Отмена',
    busy, busyLabel, error, danger, onConfirm, onCancel,
}) => (
    <Dialog open={open} modalType="alert" onOpenChange={(_, data) => { if (!data.open && !busy) onCancel(); }}>
        <DialogSurface>
            <DialogBody>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <ErrorBar message={error} />
                    {children}
                </DialogContent>
                <DialogActions>
                    <Button appearance="secondary" disabled={busy} onClick={onCancel}>{cancelLabel}</Button>
                    <Button
                        appearance="primary"
                        disabled={busy}
                        icon={busy ? <Spinner size="tiny" /> : undefined}
                        onClick={onConfirm}
                        style={danger ? { backgroundColor: 'var(--colorStatusDangerBackground3)', color: 'var(--colorNeutralForegroundOnBrand)' } : undefined}
                    >
                        {busy ? (busyLabel ?? confirmLabel) : confirmLabel}
                    </Button>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>
);

export default ConfirmDialog;
